__webpack_require__.p = "/yaman_project/";